import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from '../Picklist';
import FaView from '../FaView';
import Tran_data_unlock_request from '../Tran_data_unlock_request';
import CancelDialog from '../CancelDialog';

const Tran_vtm_settlement = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [scrMode, setScrMode] = useState("");

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isErrBox, setErrBox] = useState(false);
    const [errText, setErrText] = useState("");

    const [dataList, setDataList] = useState([]);
    const [productData, setProductData] = useState([]);
    const [paymentData, setPaymentData] = useState([]);
    const [radioType, setRadioType] = useState("S");
    const [vtmSettlementLocation, setVtmSettlementLocation] = useState(null);
    const [locationCode, setLocationCode] = useState('0');
    const [location, setLocation] = useState("");
    const [vtmFromSrno, setVtmFromSrno] = useState("");
    const [vtmToSrno, setVtmToSrno] = useState("");
    const [vtmFromDate, setVtmFromDate] = useState(new Date());
    const [vtmToDate, setVtmToDate] = useState(new Date());
    const [ledger, setLedger] = useState("");
    const [date, setDate] = useState(new Date());
    const [total, setTotal] = useState("");
    const [faViewData, setFaViewData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [hdrSrno, setHdrSrno] = useState(0);
    const [hdrType, setHdrType] = useState("");
    const [hdrLocation, setHdrLocation] = useState("");

    const [showFaView, setShowFaView] = useState(false);
    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });

    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [viewDate, setViewDate] = useState('');
    const [unlockRequestType, setUnlockRequestType] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setVtmSettlementLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_SETTLEMENT_VTM'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DELETE_BILL'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserCancelBillRight(resp);
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);


    const handleChangeLocation = (value) => {
        setVtmSettlementLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        setLocation(loc[2]);
        sessionStorage.activeBranch = loc[1];
    }


    const listData = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (vtmSettlementLocation === null) {
            $(".loader").hide();
            setMsgText("Please Select Location!");
            setMsgBox(true);
        } else if ((radioType === 'S' && !vtmFromSrno) || (radioType === 'S' && !vtmToSrno) || (radioType === 'D' && !vtmFromDate) || (radioType === 'D' && !vtmToDate)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (radioType === 'S' && !vtmFromSrno ? " From." : '');
            msg[i++] = (radioType === 'S' && !vtmToSrno ? " To." : '');
            msg[i++] = (radioType === 'D' && !vtmFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !vtmToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                locationCode: locationCode,
                filterRadioType: radioType,
                filterFromSrno: vtmFromSrno,
                filterToSrno: vtmToSrno,
                filterFromDate: Common.dateYMD(vtmFromDate),
                filterToDate: Common.dateYMD(vtmToDate),
                type: "VT"
            }
            Common.callApi(Common.apiSettlementVtm, [sid, 'list', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setDataList(resp);
                setHdrSrno(resp.hdrSrno)
            });
        }
    }


    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }


    const viewList = (hdrsrno, hdrtype, hdrlocation, locationName, ledger, total, date) => {
        $(".loader").show();
        setScrMode('Q');
        setLocation(locationName);
        setLedger(ledger);
        setTotal(total);
        setDate(date);
        setHdrType(hdrtype);
        setHdrSrno(hdrsrno);
        setHdrLocation(hdrlocation);
        setViewDate(date);
        const obj = {
            srno: hdrsrno,
            location: hdrlocation,
            type: hdrtype,
        }
        Common.callApi(Common.apiSettlementVtm, [sid, 'view', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            setProductData(resp.productData);
            setPaymentData(resp.paymentData);
        });
    }


    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: hdrLocation, trannumber: hdrSrno, type: hdrType });
    }

    const handleCancelBill = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);
        console.log(dateA);
        console.log(dateB);

        const differenceInMilliseconds = dateB - dateA;
        console.log(differenceInMilliseconds);

        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        console.log(differenceInDays);
        const obj = {
            srno: hdrSrno,
            type: 'VT',
            pageright: 'TRAN_SETTLEMENT_VTM',
            location: hdrLocation
        }

        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setMsgTextYNBillDelete("Are you sure.");
                setMsgBoxYNBillDelete(true);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'VT', trannumber: hdrSrno, location: hdrLocation, tranDate: Common.dateYMD(currDate) });
            }
        });

    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: hdrType,
            location: hdrLocation,
            srno: hdrSrno,
            productList: [],
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                listData();
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }


    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>VTM Settlement</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={vtmSettlementLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeLocation}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col><Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === 'S' ?
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control value={vtmFromSrno}
                                                        maxLength={20}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setVtmFromSrno)}
                                                        placeholder="From" />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control value={vtmToSrno}
                                                        maxLength={20}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setVtmToSrno)}
                                                        placeholder="To" />
                                                </Form.Group>
                                            </Col>
                                        </>
                                        :
                                        radioType === 'D' ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={vtmFromDate}
                                                            onChange={(date) => setVtmFromDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={vtmToDate}
                                                            onChange={(date) => setVtmToDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            :
                                            null
                                }
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        userRight.query === "1" ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => listData()}>List</Button>
                                            : null
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                {userRight.edit === "1" ? <th></th> : null}
                                                <th>Sr No</th>
                                                <th>Location</th>
                                                <th>Ledger</th>
                                                <th>Date</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                dataList.map((res) => (
                                                    <tr key={res.hdr_srno}>
                                                        {userRight.query === "1" ?
                                                            <td className="textCenter">
                                                                <span className="handCursor colorThemeBlue" onClick={() => viewList(res.hdr_srno, res.hdr_type, res.hdr_location, res.entity_name, res.ledger, res.hdr_forex_total, res.hdr_date)}>
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                </span>
                                                            </td>
                                                            : null
                                                        }
                                                        <td>{res.hdr_srno}</td>
                                                        <td>{res.entity_name}</td>
                                                        <td>{res.ledger}</td>
                                                        <td>{res.hdr_date}</td>
                                                        <td>{res.hdr_forex_total}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => cancelData()}>Back</Button> {' '}
                                    <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleFaView()}>FA View</Button>
                                    {
                                        (scrMode === "Q" && userCancelBillRight.query === "1") &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                        </>
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label><b>Location:</b> {location}</Form.Label>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label><b>Date:</b> {date}</Form.Label>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label><b>Ledger: </b>{ledger}</Form.Label>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label><b>Total:</b> {total}</Form.Label>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <h3>Product Details</h3>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                <th>Location</th>
                                                <th>ISD</th>
                                                <th>Ledger</th>
                                                <th>Date</th>
                                                <th>Product</th>
                                                <th>Denomination</th>
                                                <th>Quantity</th>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                productData.map((res) => (
                                                    <tr key={res.prd_line_no}>
                                                        <td>{res.entity_name}</td>
                                                        <td>{res.isd}</td>
                                                        <td>{res.ledger}</td>
                                                        <td>{res.prd_date}</td>
                                                        <td>{res.prd_product}</td>
                                                        <td>{res.prd_deno}</td>
                                                        <td>{res.prd_qty}</td>
                                                        <td>{res.prd_rate}</td>
                                                        <td>{res.prd_amount}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <h3>Payment Details</h3>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                <th>Location</th>
                                                <th>Ledger</th>
                                                <th>Payment Type</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                paymentData.map((res) => (
                                                    <tr key={res.tp_line_no}>
                                                        <td>{res.entity_name}</td>
                                                        <td>{res.ledger}</td>
                                                        <td>{res.tp_payment_type === "RC" ? "Receivables" :
                                                            res.tp_payment_type === "PB" ? "Payables" : res.tp_payment_type}
                                                        </td>
                                                        <td>{res.tp_amount}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </>
                }
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
                <Dialog isOpen={isErrBox} onClose={(e) => setErrBox(false)}>
                    {errText}
                </Dialog>
                <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} onNo={(e) => setMsgBoxYNBillDelete(false)}>
                    {msgTextYNBillDelete}
                </CancelDialog>
            </div>
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
            <div>
                {/* <Modal size='lg' show={showModal} onHide={() => setShowModal(false)} animation={false} centered>
                    <Modal.Body>
                        <Container fluid>
                            <Row>
                                <Col>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                <th>Location</th>
                                                <th>Type</th>
                                                <th>Date</th>
                                                <th>Flag</th>
                                                <th>Ledger</th>
                                                <th>Amount</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                faViewData.map((res) => (
                                                    <tr key={res.tfd_line_no}>
                                                        <td>{res.entity_name}</td>
                                                        <td>{res.tfd_type}</td>
                                                        <td>{res.tfd_date}</td>
                                                        <td>{res.tfd_flag === 'C' ? 'CREDIT' : 'DEBIT'}</td>
                                                        <td>{res.ledger}</td>
                                                        <td>{res.tfd_amount}</td>
                                                        <td>{res.tfd_active === '1' ? 'ACTIVE' : 'INACTIVE'}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-success" onClick={() => setShowModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal> */}
            </div>
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
        </>
    )
}

export default Tran_vtm_settlement;
